import { scrollbarStyle } from '@blocksuite/hive-shared/styles';
import { css } from 'lit';

export const codeBlockStyles = css`
  .hive-code-block-container {
    font-size: var(--hive-font-xs);
    line-height: var(--hive-line-height);
    position: relative;
    padding: 28px 24px;
    background: var(--hive-background-code-block);
    border-radius: 10px;
    box-sizing: border-box;
  }

  .hive-code-block-container.mobile {
    padding: 12px;
  }

  ${scrollbarStyle('.hive-code-block-container rich-text')}

  .hive-code-block-container .inline-editor {
    font-family: var(--hive-font-code-family);
    font-variant-ligatures: none;
  }

  .hive-code-block-container v-line {
    position: relative;
    display: inline-grid !important;
    grid-template-columns: auto minmax(0, 1fr);
  }

  .hive-code-block-container div:has(> v-line) {
    display: grid;
  }

  .hive-code-block-container .line-number {
    position: sticky;
    text-align: left;
    padding-right: 4px;
    width: 24px;
    word-break: break-word;
    white-space: nowrap;
    left: -0.5px;
    z-index: 1;
    background: var(--hive-background-code-block);
    font-size: var(--hive-font-xs);
    line-height: var(--hive-line-height);
    color: var(--hive-text-secondary);
    box-sizing: border-box;
    user-select: none;
  }
`;
